// web_common_area_getInternationalAreaChildListByParentId 根据id获取子列表(国际),参数 id

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 根据id获取城市省份接口地址：http://219.128.52.2:9999/doc.html#/所有接口/area-controller/getInternationalAreaChildListByParentIdUsingPOST

export default function web_common_area_getInternationalAreaChildListByParentId(pParameter) {
  if (!pParameter) pParameter = {};
  const id = pParameter.id || 0
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/common/area/getInternationalAreaChildListByParentId'
  params.data = {id};
  params.process_response_data = false;
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}

